if (!customElements.get('queue-job')) {
    class QueueJob extends HTMLElement {

        constructor() {
            super();
            this._value = 0;
            this._max = 100;
            this.startColor = 'e40505';
            this.endColor = '00f600';
            this.progress = this.querySelector('.progress');
            this.runningText = this.querySelector('[data-running]');
            this.pauseText = this.querySelector('[data-pause]');
            this.readyText = this.querySelector('[data-ready]');
            this.abort = this.querySelector('[data-abort');
            this.endTimeout = null;
            this.aborted = false;
        }

        set value(val) {
            this._value = val;
            this.progress.style.setProperty('--value', val);
            this.updateState();
        }

        get value() {
            return this._value;
        }

        set max(val) {
            this._max = val;
            this.progress.style.setProperty('--max', val);
            this.updateState();
        }

        get max() {
            return this._max;
        }

        get color() {
            const ratio = this._value / this._max;
            var r = Math.ceil(parseInt(this.endColor.substring(0, 2), 16) * ratio + parseInt(this.startColor.substring(0, 2), 16) * (1 - ratio));
            var g = Math.ceil(parseInt(this.endColor.substring(2, 4), 16) * ratio + parseInt(this.startColor.substring(2, 4), 16) * (1 - ratio));
            var b = Math.ceil(parseInt(this.endColor.substring(4, 6), 16) * ratio + parseInt(this.startColor.substring(4, 6), 16) * (1 - ratio));
            return '#' + this._hex(r) + this._hex(g) + this._hex(b);
        }

        connectedCallback() {
            // document.addEventListener('queue-job:show', this.handleShow.bind(this));
            // document.addEventListener('queue-job:max', this.handleMax.bind(this));
            // document.addEventListener('queue-job:increase-max', this.handleIncreaseMax.bind(this));
            // document.addEventListener('queue-job:hide', this.handleHide.bind(this));
            // document.addEventListener('queue-job:update', this.handleUpdate.bind(this));
            // document.addEventListener('queue-job:step', this.handleStep.bind(this));
            // document.addEventListener('queue-job:pause', this.handlePause.bind(this));
            // document.addEventListener('queue-job:end', this.handleEnd.bind(this));
            // this.abort.addEventListener('click', this.handleAbort.bind(this));
        }

        disconnectedCallback() {
            // document.removeEventListener('queue-job:show', this.handleShow.bind(this));
            // document.removeEventListener('queue-job:max', this.handleMax.bind(this));
            // document.removeEventListener('queue-job:increase-max', this.handleIncreaseMax.bind(this));
            // document.removeEventListener('queue-job:hide', this.handleHide.bind(this));
            // document.removeEventListener('queue-job:update', this.handleUpdate.bind(this));
            // document.removeEventListener('queue-job:step', this.handleStep.bind(this));
            // document.removeEventListener('queue-job:pause', this.handlePause.bind(this));
            // document.removeEventListener('queue-job:end', this.handleEnd.bind(this));
            // this.abort.removeEventListener('click', this.handleAbort.bind(this));
        }

        handleAbort() {
            if (this.aborted) {
                return;
            }
            this.aborted = true;
            window.fetchQueue.abort();
        }

        updateState() {
            this.progress.style.setProperty('--color', this.color);
            if (this.endTimeout != null) {
                clearTimeout(this.endTimeout);
            }
            if (this.value >= this.max) {
                this.classList.add('done');
                this.runningText.classList.add('hidden');
                this.pauseText.classList.add('hidden');
                this.readyText.classList.remove('hidden');
            } else {
                this.classList.remove('done');
                this.runningText.classList.remove('hidden');
                this.pauseText.classList.add('hidden');
                this.readyText.classList.add('hidden');
            }
        }

        handlePause({ detail }) {
            if (detail) {
                this.runningText.classList.add('hidden');
                this.pauseText.classList.remove('hidden');
            } else {
                this.runningText.classList.remove('hidden');
                this.pauseText.classList.add('hidden');
            }
        }

        handleShow({ detail }) {
            if (detail) {
                this.max = detail;
            }
            this.classList.add('active');
        }

        handleMax({ detail }) {
            this.max = detail;
        }

        handleIncreaseMax({ detail }) {
            this.max += detail;
        }

        handleHide() {
            this.classList.remove('active');
            this.endTimeout = null;
            setTimeout(() => {
                this.max = 100;
                this.value = 0;
                this.aborted = false;
            }, 1000);
        }

        handleUpdate({ detail }) {
            this.value = detail;
        }

        handleStep() {
            this.value = this.value + 1;
        }

        handleEnd() {
            this.value = this.max;
            this.endTimeout = setTimeout(() => {
                this.handleHide();
            }, 3000);
        }

        _hex(x) {
            x = x.toString(16);
            return (x.length == 1) ? '0' + x : x;
        }
    }

    customElements.define('queue-job', QueueJob);
}